import { ExternalLink } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="py-8 mt-12 border-t border-white/10" data-testid="app-footer">
      <div className="max-w-md mx-auto md:max-w-4xl lg:max-w-6xl px-4 md:px-8 space-y-8">
        
        {/* Book Advertisement */}
        <div className="glass-card p-6 max-w-sm mx-auto">
          <a 
            href="https://umbrellasalesbook.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="block group"
            data-testid="book-ad-link"
          >
            <div className="relative overflow-hidden rounded-lg mb-4">
              <img 
                src="https://umbrellasalesbook.com/assets/cover.png"
                alt="Sales Linkage Book - Why Do I Need an Umbrella?"
                className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-300"
                loading="lazy"
              />
            </div>
            <p className="text-center text-sm text-slate-400 group-hover:text-cosmic-blue transition-colors">
              Learn to sell or teach others to sell
            </p>
            <div className="flex items-center justify-center gap-1 mt-2 text-cosmic-blue group-hover:text-cosmic-blue-glow transition-colors">
              <span className="text-xs font-heading uppercase tracking-wider">Get the Book</span>
              <ExternalLink className="w-3 h-3" strokeWidth={1.5} />
            </div>
          </a>
        </div>

        {/* Project Links */}
        <div className="text-center space-y-4">
          <p className="text-sm text-slate-500">
            Check out his other projects:{" "}
            <a 
              href="https://thepmaproject.org/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-cosmic-blue hover:text-cosmic-blue-glow underline underline-offset-2"
              style={{ transition: "color 0.2s ease" }}
            >
              thepmaproject.org
            </a>
            {" "}&{" "}
            <a 
              href="https://repliantarc.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-cosmic-blue hover:text-cosmic-blue-glow underline underline-offset-2"
              style={{ transition: "color 0.2s ease" }}
            >
              repliantarc.com
            </a>
          </p>
          
          {/* Copyright */}
          <p className="text-xs text-slate-600 font-heading">
            Created by <span className="text-slate-400">Patrick M. Arcement</span> / The PMA Project 2026 (c)
          </p>
        </div>
      </div>
    </footer>
  );
};
